<!--  -->
<template>
    <div class='left2_container box_v'>
        <div class="title">预告类当月每日办件</div>
        <div class='box_f1' id="echart_daily_yugao" style="width:100%;height:100%"></div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    props:['communityId'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            mon:[],
            handelData:[],
            handelTag:'件',
            communityIds:1
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        communityId:{
            handler(newVal){
                if(this.communityIds != newVal){
                    this.communityIds = newVal;
                    this.getData(this.communityIds)
                }
            },
            deep:true
        }
    },
    //方法集合
    methods: {
        getData(communityId){
            this.$get(this.urlobj.getDailyHandleCount,{
                type:1,
                communityId:communityId
            }).then(res=>{
                this.mon = res.rows.map(item=>item.dateTime)
                let handelData = res.rows.map(item=>item.handleCount)
                this.handelData = this.$util.handleNumber(handelData).numArr
                this.handelTag = this.$util.handleNumber(handelData).tag
                this.$nextTick(()=>{
                    this.initEcharts()
                })
            })
        },
        initEcharts(){
            let echart = echarts.init(document.getElementById('echart_daily_yugao'));
           
            let option = {
                xAxis: {
                    type: 'category',
                    data: this.mon,
                    barCategoryGap: '15px',                    
                    axisLabel: {
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    axisLine:{show: false}
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        textStyle: {
                            color: '#67B800'
                        },
                        formatter: '{value}' + this.handelTag,
                    },
                    splitLine:{show: false},//去除网格线
                    axisLine:{show: false}
                },
                // legend: {
                //     data: ['业务办理量'],
                //     right:'20',
                //     icon:'roundRect',
                //     textStyle:{
                //         color:'#fff'
                //     }
                // },
                series: [{
                    name:'每日办件',
                    data: this.handelData,
                    type: 'line',
                    smooth:true,
                    symbol: 'none',
                    lineStyle:{
                        color:'#00B879'
                    },
                    areaStyle:{
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#047397'
                            }, {
                                offset: 1, color: 'rgba(6, 27, 84, 0)' // 100% 处的颜色
                            }],
                            global: false // 缺省为 false
                        }
                    }
                }],
                tooltip:{
                    trigger:'axis',
                    formatter:'{c}'+this.handelTag,
                    backgroundColor:'rgba(255,255,255,0)',
                    textStyle:{
                        color:'#00B879'
                    }
                }
            };
            

            echart.setOption(option)
            // echart1.on('click', (params)=>{
            //     this.getQyList(params.dataIndex)
            //     console.log(params.dataIndex);
            // });
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData(this.communityIds)
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.left2_container{
    background-image: url('../../../../assets/images/monitorpy/leftbottom.png');
    background-size: 100% 100%;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-left: 40px;
    margin-top: 20px
}
</style>